import {
    FETCH_STYLE_PRE_DIA_REQUEST,
    FETCH_STYLE_PRE_DIA_SUCCESS,
    FETCH_STYLE_PRE_DIA_FAILURE,
    CREATE_STYLE_PRE_DIA_FORM,
    UPDATE_STYLE_PRE_DIA_FORM,
    CREATE_STYLE_PRE_DIA_SUCCESS,
    FETCH_SINGLE_STYLE_PRE_DIA_SUCCESS,
    UPDATE_STYLE_PRE_DIA_SUCCESS,
    DELETE_STYLE_PRE_DIA_SUCCESS,
    CREATE_STYLE_PRE_DIA_REQUEST,
    UPDATE_STYLE_PRE_DIA_REQUEST,
    FETCH_SINGLE_STYLE_PRE_DIA_REQUEST,
    DELETE_STYLE_PRE_DIA_REQUEST,
    RESET_STYLE_PRE_DIA_INFO,
    CREATE_STYLE_PRE_DIA_FAILURE,
    UPDATE_STYLE_PRE_DIA_FAILURE,
    FETCH_SINGLE_STYLE_PRE_DIA_FAILURE,
    DELETE_STYLE_PRE_DIA_FAILURE,
    FETCH_STYLE_PRE_ALL_DIA_SUCCESS,
    FETCH_STYLE_PRE_ALL_DIA_REQUEST,
    FETCH_STYLE_PRE_ALL_DIA_FAILURE,
    FETCH_STYLE_PRE_DIA_BY_STYLE_AND_SUB_STYLE_REQUEST,
    FETCH_STYLE_PRE_DIA_BY_STYLE_AND_SUB_STYLE_SUCCESS,
    FETCH_STYLE_PRE_DIA_BY_STYLE_AND_SUB_STYLE_FAILURE,
    FETCH_STYLE_PRE_DIA_BY_PART_REQUEST,
    FETCH_STYLE_PRE_DIA_BY_PART_SUCCESS,
    FETCH_STYLE_PRE_DIA_BY_PART_FAILURE,
} from './stylePreDia.actionType';

export const STYLE_PRE_DIA = 'stylePreDia';

let initialState = {
    loading: false,
    stylePreDiaList: [],
    diaListBySTyleAndSubStyle: [],
    stylePreAllDiaList: [],
    stylePreAllDiaListByPart: [],
    stylePreDiaForm: {},
    selectedState: {},
    diaResponseStatus: '',
    errorMessage: '',

};

export let stylePreDiaReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_STYLE_PRE_DIA_REQUEST:
        case FETCH_STYLE_PRE_DIA_BY_PART_REQUEST:
        case FETCH_STYLE_PRE_DIA_BY_STYLE_AND_SUB_STYLE_REQUEST:
        case CREATE_STYLE_PRE_DIA_REQUEST:
        case UPDATE_STYLE_PRE_DIA_REQUEST:
        case FETCH_STYLE_PRE_ALL_DIA_REQUEST:
        case FETCH_SINGLE_STYLE_PRE_DIA_REQUEST:
        case DELETE_STYLE_PRE_DIA_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_STYLE_PRE_DIA_SUCCESS:
            let fields = ['Dia', 'Gage', 'Loop length', 'LoopLength2', 'FinishingDia'];
            updatePayload.sort((a, b) => {
                return fields.indexOf(a.fldDiaType) - fields.indexOf(b.fldDiaType);
            });
            return {
                ...state,
                loading: false,
                stylePreDiaList: updatePayload,
            };

        case FETCH_STYLE_PRE_DIA_BY_PART_SUCCESS:
            return {
                ...state,
                loading: false,
                stylePreAllDiaListByPart: updatePayload
            };
        case FETCH_STYLE_PRE_DIA_BY_STYLE_AND_SUB_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                diaListBySTyleAndSubStyle: updatePayload
            };
        case FETCH_STYLE_PRE_ALL_DIA_SUCCESS:
            return {
                ...state,
                loading: false,
                stylePreAllDiaList: updatePayload
            };
        case CREATE_STYLE_PRE_DIA_SUCCESS:
            return {
                ...state,
                loading: false,
                stylePreDiaForm: {},
                diaResponseStatus: updatePayload
            };
        case UPDATE_STYLE_PRE_DIA_SUCCESS:
            return {
                ...state,
                loading: false,
                stylePreDiaForm: {}
            };
        case FETCH_SINGLE_STYLE_PRE_DIA_SUCCESS:
            return {
                ...state,
                loading: false,
                stylePreDiaForm: updatePayload
            };
        case DELETE_STYLE_PRE_DIA_SUCCESS:
            return {
                ...state,
                loading: false,
                stylePreDiaForm: {}
            };
        case RESET_STYLE_PRE_DIA_INFO:
            return {
                ...state,
                stylePreDiaForm: {},
                stylePreDiaList: []
            };
        case CREATE_STYLE_PRE_DIA_FORM:
        case UPDATE_STYLE_PRE_DIA_FORM:
            return {
                ...state,
                loading: false,
                stylePreDiaForm: {
                    ...state.stylePreDiaForm,
                    [payload.key]: payload.value
                }
            };
        case CREATE_STYLE_PRE_DIA_FAILURE:
        case UPDATE_STYLE_PRE_DIA_FAILURE:
            return {
                ...state,
                loading: false,
                diaResponseStatus: updatePayload?.status
            };
        case FETCH_STYLE_PRE_DIA_FAILURE:
        case FETCH_STYLE_PRE_DIA_BY_PART_FAILURE:
        case FETCH_STYLE_PRE_DIA_BY_STYLE_AND_SUB_STYLE_FAILURE:
        case FETCH_SINGLE_STYLE_PRE_DIA_FAILURE:
        case FETCH_STYLE_PRE_ALL_DIA_FAILURE:
        case DELETE_STYLE_PRE_DIA_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
